<!-- Announcement bar -->
<div class="h1-announcement">
  <div class="h1-announcement__inner">
    <span class="h1-announcement__pill">New</span>
    <span class="h1-announcement__text">
      September intake scholarships open · save up to <strong>35%</strong> on tuition
    </span>
    <a href="#cta" class="h1-announcement__cta">
      Claim now
      <span aria-hidden="true">→</span>
    </a>
  </div>
</div>

<!-- Header / Navbar -->
<header class="h1-header">
  <div class="h1-header__inner">
    <a routerLink="/home1" class="h1-logo">
      <span class="h1-logo__img-frame">
        <img
          class="h1-logo__img"
          src="/assets/images/logo.webp"
          alt=""
          width="200"
          height="52"
        />
      </span>
      <span class="h1-logo__wordmark">Careergrad Global</span>
    </a>

    <nav class="h1-nav" aria-label="Primary">
      @for (link of navLinks; track link.label) {
        <a [href]="link.href" class="h1-nav__link">{{ link.label }}</a>
      }
    </nav>

    <div class="h1-header__cta">
      <a href="#cta" class="h1-btn h1-btn--ghost">Book Free Counseling</a>
      <a href="#cta" class="h1-btn h1-btn--primary">Apply Now</a>
    </div>
  </div>
</header>

<!-- Hero -->
<section class="h1-hero">
  <div class="h1-hero__bg" aria-hidden="true"></div>
  <div class="h1-hero__inner">
    <div class="h1-hero__copy">
      <span class="h1-badge">
        <span class="h1-badge__dot"></span>
        Trusted by 12,000+ students globally
      </span>
      <h1 class="h1-hero__title">
        Your Global<br />
        Education
        <span class="h1-hero__highlight">Journey</span>
        Starts<br />
        Here
      </h1>
      <p class="h1-hero__lede">
        Personalized counseling, scholarship support and visa expertise — built around
        ambitious students who want to study abroad without the guesswork.
      </p>

      <ul class="h1-hero__features">
        @for (feature of heroFeatures; track feature) {
          <li>
            <span class="h1-hero__check" aria-hidden="true">✓</span>
            {{ feature }}
          </li>
        }
      </ul>

      <div class="h1-hero__actions">
        <a href="#cta" class="h1-btn h1-btn--accent h1-btn--lg">Get Counseling</a>
        <a href="#destinations" class="h1-btn h1-btn--glass h1-btn--lg">Explore Destinations</a>
      </div>
    </div>

    <div class="h1-hero__art" aria-hidden="true">
      <div class="h1-hero-card h1-hero-card--back"></div>
      <div class="h1-hero-card h1-hero-card--front">
        <img src="/assets/images/students.jpg" alt="" loading="eager" onerror="this.style.display='none'" />
      </div>
      <div class="h1-hero-badge">
        <div class="h1-hero-badge__value">100K+</div>
        <div class="h1-hero-badge__label">Lives changed</div>
      </div>
    </div>
  </div>
</section>

<!-- Stats -->
<section class="h1-stats">
  <div class="h1-stats__card">
    @for (stat of stats; track stat.label) {
      <div class="h1-stat">
        <div class="h1-stat__value">{{ stat.value }}</div>
        <div class="h1-stat__label">{{ stat.label }}</div>
      </div>
    }
  </div>
</section>

<!-- Top Study Destinations -->
<section class="h1-section h1-section--cool" id="destinations">
  <div class="h1-section__inner">
    <header class="h1-section__head">
      <h2>Top Study Destinations</h2>
      <p>Handpicked countries with strong post-study work options, scholarship coverage and English-taught programs.</p>
    </header>

    <div class="h1-dest-grid">
      @for (d of destinations; track d.name) {
        <a href="#" class="h1-dest-card" [class]="'h1-dest-card--' + d.image">
          <div class="h1-dest-card__media" [style.background-image]="'url(/assets/images/destinations/' + d.image + '.jpg)'"></div>
          <div class="h1-dest-card__overlay"></div>
          <div class="h1-dest-card__body">
            <span class="h1-dest-card__flag">{{ d.flag }}</span>
            <div class="h1-dest-card__name">{{ d.name }}</div>
            <div class="h1-dest-card__meta">{{ d.universities }}+ universities</div>
          </div>
        </a>
      }
    </div>

    <div class="h1-dest-mini">
      @for (d of miniDestinations; track d.name) {
        <a href="#" class="h1-dest-mini-card">
          <span class="h1-dest-mini-card__flag">{{ d.flag }}</span>
          <span class="h1-dest-mini-card__name">{{ d.name }}</span>
          <span class="h1-dest-mini-card__arrow" aria-hidden="true">→</span>
        </a>
      }
    </div>
  </div>
</section>

<!-- Global Success Stories: featured milestone + testimonial cards -->
<section class="h1-section h1-section--warm">
  <div class="h1-section__inner">
    <header class="h1-section__head h1-section__head--center">
      <h2>Global Success Stories</h2>
      <p>Real journeys, life-changing achievements, and global impact.</p>
    </header>

    <div class="h1-slider" role="region" aria-roledescription="carousel" aria-label="Featured milestones">
      <div class="h1-slider__viewport">
        <div class="h1-slider__track"
             [style.transform]="'translateX(' + (-milestoneSlide() * 100) + '%)'">
          @for (m of milestones; track m.title) {
            <div class="h1-slider__slide" [attr.aria-hidden]="milestoneSlide() !== $index">
              <article class="h1-milestone">
                <div class="h1-milestone__copy">
                  <span class="h1-milestone__pill">{{ m.pill }}</span>
                  <h3>
                    @for (line of m.title.split('\n'); track $index) {
                      {{ line }}
                      @if (!$last) { <br /> }
                    }
                  </h3>
                  <p>{{ m.description }}</p>
                  <a [href]="m.ctaHref" class="h1-milestone__cta">
                    {{ m.ctaLabel }}
                    <span aria-hidden="true">→</span>
                  </a>
                </div>
                <div class="h1-milestone__media" aria-hidden="true">
                  <img [src]="'/assets/images/milestones/' + m.image + '.jpg'"
                       alt="" loading="lazy"
                       onerror="this.style.display='none'" />
                </div>
              </article>
            </div>
          }
        </div>
      </div>

      <div class="h1-slider__controls">
        <button type="button" class="h1-slider__arrow"
                (click)="prevMilestoneSlide()"
                [disabled]="milestoneSlide() === 0"
                aria-label="Previous milestone">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" focusable="false">
            <path d="m15 18-6-6 6-6"></path>
          </svg>
        </button>

        <div class="h1-slider__dots" role="tablist" aria-label="Select milestone slide">
          @for (m of milestones; track $index) {
            <button type="button" role="tab"
                    class="h1-slider__dot"
                    [class.is-active]="milestoneSlide() === $index"
                    [attr.aria-selected]="milestoneSlide() === $index"
                    [attr.aria-label]="'Show milestone ' + ($index + 1)"
                    (click)="setMilestoneSlide($index)"></button>
          }
        </div>

        <button type="button" class="h1-slider__arrow"
                (click)="nextMilestoneSlide()"
                [disabled]="milestoneSlide() === milestones.length - 1"
                aria-label="Next milestone">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" focusable="false">
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      </div>
    </div>

    <div class="h1-slider" role="region" aria-roledescription="carousel" aria-label="Student testimonials">
      <div class="h1-slider__viewport">
        <div class="h1-slider__track"
             [style.transform]="'translateX(' + (-testimonialSlide() * 100) + '%)'">
          @for (slide of testimonialSlides(); track $index) {
            <div class="h1-slider__slide" [attr.aria-hidden]="testimonialSlide() !== $index">
              <div class="h1-testimonials">
                @for (t of slide; track t.name) {
                  <article class="h1-testimonial">
                    <div class="h1-testimonial__stars" [attr.aria-label]="t.rating + ' out of 5 stars'">
                      @for (_ of [1,2,3,4,5]; track $index) {
                        <span aria-hidden="true">★</span>
                      }
                    </div>
                    <p class="h1-testimonial__quote">"{{ t.review }}"</p>
                    <div class="h1-testimonial__person">
                      <div class="h1-testimonial__avatar"
                           [style.background-image]="'url(/assets/images/testimonials/' + t.avatar + '.jpg)'">
                        <span>{{ t.name.charAt(0) }}</span>
                      </div>
                      <div>
                        <div class="h1-testimonial__name">{{ t.name }}</div>
                        <div class="h1-testimonial__course">{{ t.course }}</div>
                      </div>
                    </div>
                  </article>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <div class="h1-slider__controls">
        <button type="button" class="h1-slider__arrow"
                (click)="prevTestimonialSlide()"
                [disabled]="testimonialSlide() === 0"
                aria-label="Previous testimonials">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" focusable="false">
            <path d="m15 18-6-6 6-6"></path>
          </svg>
        </button>

        <div class="h1-slider__dots" role="tablist" aria-label="Select testimonial slide">
          @for (slide of testimonialSlides(); track $index) {
            <button type="button" role="tab"
                    class="h1-slider__dot"
                    [class.is-active]="testimonialSlide() === $index"
                    [attr.aria-selected]="testimonialSlide() === $index"
                    [attr.aria-label]="'Show slide ' + ($index + 1)"
                    (click)="setTestimonialSlide($index)"></button>
          }
        </div>

        <button type="button" class="h1-slider__arrow"
                (click)="nextTestimonialSlide()"
                [disabled]="testimonialSlide() === testimonialSlides().length - 1"
                aria-label="Next testimonials">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" focusable="false">
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</section>

<app-marketing-why-choose />

<app-marketing-success-roadmap />


<!-- Partner Universities -->
<section class="h1-universities" id="universities">
  <div class="h1-universities__inner">
    <header class="h1-universities__head">
      <span class="h1-eyebrow h1-eyebrow--on-dark">Our Partner Universities</span>
      <h2>500+ partner institutions across the world</h2>
      <p>Trusted by globally ranked universities to send well-prepared, well-funded international students every year.</p>
      <a href="#cta" class="h1-btn h1-btn--accent">View all partners</a>
    </header>

    <div class="h1-universities__grid">
      @for (uni of universities; track uni.slug) {
        <div class="h1-uni-card" [title]="uni.name">
          <div class="h1-uni-card__logo">
            <img [src]="'/assets/images/universities/logo-' + uni.slug + '.svg'"
                 [alt]="uni.name"
                 onerror="this.style.display='none'" />
            <span class="h1-uni-card__placeholder">{{ uni.name }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- Final CTA + Form -->
<section class="h1-cta" id="cta">
  <div class="h1-cta__inner">
    <div class="h1-cta__copy">
      <span class="h1-eyebrow h1-eyebrow--on-dark">Ready to begin?</span>
      <h2>
        Take the <span class="h1-cta__highlight">Next Step</span><br />
        of your global career.
      </h2>
      <p>Talk to a senior counselor in 24 hours. No spam, no sales pitch, no upsells — just a clear plan tailored to your goals.</p>
      <ul class="h1-cta__bullets">
        <li><span aria-hidden="true">✓</span> Free 45-minute consultation</li>
        <li><span aria-hidden="true">✓</span> University shortlist within a week</li>
        <li><span aria-hidden="true">✓</span> Scholarship discovery built in</li>
      </ul>
    </div>

    <form class="h1-cta__form" (submit)="$event.preventDefault(); onLeadSubmit()" novalidate>
      <h3>Book a Free Consultation</h3>
      <label>
        <span>Full name</span>
        <input type="text" name="fullName" [(ngModel)]="form.fullName" required placeholder="e.g. Aanya Patel" />
      </label>
      <label>
        <span>Email</span>
        <input type="email" name="email" [(ngModel)]="form.email" required placeholder="you@email.com" />
      </label>
      <label>
        <span>Phone</span>
        <input type="tel" name="phone" [(ngModel)]="form.phone" required placeholder="+91 98765 43210" />
      </label>
      <label>
        <span>Preferred destination</span>
        <select name="destination" [(ngModel)]="form.destination">
          <option value="" disabled selected>Select a country</option>
          <option value="germany">Germany</option>
          <option value="france">France</option>
          <option value="uk">United Kingdom</option>
          <option value="canada">Canada</option>
          <option value="usa">United States</option>
          <option value="australia">Australia</option>
          <option value="ireland">Ireland</option>
          <option value="newzealand">New Zealand</option>
        </select>
      </label>
      <button type="submit" class="h1-btn h1-btn--accent h1-btn--lg h1-btn--block">Request callback</button>
      <p class="h1-cta__small">By submitting you agree to our terms &amp; privacy policy.</p>
    </form>
  </div>
</section>

<!-- Footer -->
<footer class="h1-footer">
  <div class="h1-footer__inner">
    <div class="h1-footer__brand">
      <a routerLink="/home1" class="h1-logo h1-logo--on-dark">
        <span class="h1-logo__img-frame">
          <img
            class="h1-logo__img"
            src="/assets/images/logo.webp"
            alt=""
            width="200"
            height="52"
          />
        </span>
        <span class="h1-logo__wordmark">Careergrad Global</span>
      </a>
      <p>Helping ambitious students study abroad with clarity, confidence and the right scholarships.</p>

      <form class="h1-footer__newsletter" (submit)="$event.preventDefault()" novalidate>
        <input type="email" placeholder="Your email address" aria-label="Newsletter email" />
        <button type="submit" class="h1-btn h1-btn--accent">Subscribe</button>
      </form>

      <div class="h1-footer__socials" aria-label="Social links">
        <a href="#" aria-label="Instagram">IG</a>
        <a href="#" aria-label="LinkedIn">in</a>
        <a href="#" aria-label="YouTube">YT</a>
        <a href="#" aria-label="Twitter">X</a>
      </div>
    </div>

    @for (col of footerColumns; track col.heading) {
      @if ($index > 0) {
        <div class="h1-footer__col">
          <div class="h1-footer__heading">{{ col.heading }}</div>
          <ul>
            @for (l of col.links; track l.label) {
              <li><a [href]="l.href">{{ l.label }}</a></li>
            }
          </ul>
        </div>
      }
    }
  </div>

  <div class="h1-footer__bar">
    <div class="h1-footer__bar-inner">
      <span>© 2026 Career Grad. All rights reserved.</span>
      <span>
        <a href="#">Privacy</a>
        <span aria-hidden="true">·</span>
        <a href="#">Terms</a>
        <span aria-hidden="true">·</span>
        <a href="#">Cookies</a>
      </span>
    </div>
  </div>
</footer>
